import React, { ReactElement } from 'react';

interface PageTitleProps {
  isLoading?: boolean;
  label: string;
  data: string | undefined;
  className?: string;
}

function DataLabel({
  isLoading = false,
  label,
  data,
  className = ''
}: PageTitleProps): ReactElement {
  return !isLoading ? (
    <div className={`flex flex-row ${className}`}>
      <div>{label}:</div>
      <div>{data}</div>
    </div>
  ) : (
    <div className={`flex flex-row mb-1 ${className}`}>
      <div className="h-3 bg-gray-300 rounded-lg w-20 font-semibold text-gray-800 animate-pulse" />
      <div className="h-3  bg-gray-300 rounded-lg w-20 font-semibold text-gray-800 animate-pulse " />
    </div>
  );
}

export default DataLabel;
